import { useAuth, overrideConfig } from '@/api/hyper-common'

const fetchAssignedCardAccounts = function ({ usageAccountIds, projectIdxs }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.post('/v1/hyper-common/credit-card/card-assignment', { usageAccountIds, projectIdxs })
}

const fetchAssignedCardPaymentInfo = function ({ assignedIdxs, projectIdxs }, serviceIdx) {
    const { auth } = useAuth({ ...overrideConfig, serviceIdx })
    return auth.axiosIns.post('/v1/hyper-common/credit-card/card-assignment/payment/info', { assignedIdxs, projectIdxs })
}

export default {
    fetchAssignedCardAccounts,
    fetchAssignedCardPaymentInfo
}
